import i18n from '@/i18n'
import { mapActions} from 'vuex'
import { DialogType } from '@/constants/constants'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'RusConfigurationTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        isThingABM: {
            type: Boolean,
            required: false
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        selectedRus: null,
        units: [
            { id: 'KM', name: i18n.t('units.KM') },
            { id: 'M', name: i18n.t('units.M') },
            { id: 'MILES', name: i18n.t('units.MILES') },
            { id: 'KG', name: i18n.t('units.KG') },
            { id: 'G', name: i18n.t('units.G') },
            { id: 'KPH', name: i18n.t('units.KPH') },
            { id: 'MPH', name: i18n.t('units.MPH') },
            { id: 'KNOT', name: i18n.t('units.KNOT') },
            { id: 'DECASECONDS', name: i18n.t('units.DECASECONDS') },
            { id: 'SECONDS', name: i18n.t('units.SECONDS') },
            { id: 'HOUR', name: i18n.t('units.HOUR') },
            { id: 'MILISECONDS', name: i18n.t('units.MILISECONDS') },
            { id: 'PPS', name: i18n.t('units.PPS') },
            { id: 'RPM', name: i18n.t('units.RPM') },
            { id: 'DM', name: i18n.t('units.DM') }
        ],
        tableHeaders: [],
        tableData: [],
        rusesState: {},
    }),
    computed: {
        /**
         * Chequea si el rus tiene algún error entre las propiedades.
         * Setea el estado de error y el mensaje a mostrar
         */
        rusErrorMessage () {
            const result = !this.validRus(this.tableData) || !this.isValidForm ? this.$t('enterprise.rusDialog.stateError') : null
            if (result) {
                this.rusesState[this.selectedRus] = { icon: 'mdi-close-circle', color: 'error', text: this.$t('enterprise.rusDialog.stateError')}
            } else if (!this.rusEmpty) {
                this.rusesState[this.selectedRus] = { icon: 'mdi-check-circle', color: 'success', text: this.$t('enterprise.rusDialog.stateSuccess')}
            }
            return result
        },
        rusEmpty () {
            const result = !this.tableData || this.tableData.length <= 0 ? this.$t('enterprise.rusDialog.stateWarning') : null
            if (result) {
                this.rusesState[this.selectedRus] = this.rusesState[this.selectedRus] = { icon: 'mdi-alert-circle', color: 'warning', text: this.$t('enterprise.rusDialog.stateWarning')}
            }
            return result
        }
    },
    created () {
    },
    mounted () {
        if(this.model.isThingABM){
            this.tableHeaders = [
                { text: '', value: 'actions' },
                { text: this.$t('enterprise.rusDialog.property'), value: 'property' },
                { text: this.$t('enterprise.rusDialog.unit'), value: 'unit' },
                { text: this.$t('enterprise.rusDialog.adjustment'), value: 'adjustment' },
                { text: this.$t('enterprise.rusDialog.mapTo'), value: 'mapTo' },
            ]
        }
        else {
            this.tableHeaders = [
            { text: '', value: 'actions' },
            { text: this.$t('enterprise.rusDialog.property'), value: 'property' },
            { text: this.$t('enterprise.rusDialog.unit'), value: 'unit' },
            { text: this.$t('enterprise.rusDialog.mapTo'), value: 'mapTo' },
        ]
        }
        if (this.rusesState === {} && this.model.ruses) {
            for (const r of this.model.ruses) {
                if (!this.model.rusConfigurations[r.name] || this.model.rusConfigurations[r.name].length <= 0) {
                    this.rusesState[r.name] = { icon: 'mdi-alert-circle', color: 'warning', text: this.$t('enterprise.rusDialog.stateWarning')}
                } else if (!this.validRus(this.model.rusConfigurations[r.name])) {
                    this.rusesState[r.name] = { icon: 'mdi-close-circle', color: 'error', text: this.$t('enterprise.rusDialog.stateError')}
                } else {
                    this.rusesState[r.name] = { icon: 'mdi-check-circle', color: 'success', text: this.$t('enterprise.rusDialog.stateSuccess')}
                }
            }
        }
        this.units.sort(function sort (a, b) {
            const nameA = a.name.toLowerCase()
            const nameB = b.name.toLowerCase()
            if (nameA < nameB) {
                return -1
            } else if (nameA > nameB) {
                return 1
            } else {
                return 0
            }
        })
    },
    methods: {
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        changeSelectedRus () {
            if (this.selectedRus) {
                if (!this.model.rusConfigurations[this.selectedRus]) {
                    this.model.rusConfigurations[this.selectedRus] = []
                }
                this.tableData.cleanAndUpdate(this.model.rusConfigurations[this.selectedRus]);
            } else {
                this.tableData.cleanAndUpdate([])
            }
        },
        addRusConfig () {
            if(this.model.isThingABM){
                if (this.model.rusConfigurations[this.selectedRus]) {
                    this.model.rusConfigurations[this.selectedRus].push({ property: null, mapTo: null, unit: null, adjustment: null })
                } else {
                    this.model.rusConfigurations[this.selectedRus] = [{ property: null, mapTo: null, unit: null, adjustment: null }]
                }
            }
            else {
                if (this.model.rusConfigurations[this.selectedRus]) {
                    this.model.rusConfigurations[this.selectedRus].push({ property: null, mapTo: null, unit: null })
                } else {
                    this.model.rusConfigurations[this.selectedRus] = [{ property: null, mapTo: null, unit: null }]
                }
            }
           
            this.tableData.cleanAndUpdate(this.model.rusConfigurations[this.selectedRus])
        },
        deleteRusConfig (tableProps) {
            this.tableData.splice(this.tableData.indexOf(tableProps.item), 1)
            this.model.rusConfigurations[this.selectedRus].cleanAndUpdate(this.tableData)
        },
        validRus (rus) {
            if (rus.filter(r => !r.property).length > 0) {
                return false
            }
            let seen = new Set()
            return !(rus.some(e => seen.size === seen.add(e.property).size))
        },
        applyEnterpriseConfig () {
            this.openDialog({
                title: this.$t('enterprise.rusDialog.applyEnterpriseConfig'),
                text: this.$t('enterprise.rusDialog.applyEnterpriseConfigConfirmation'),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: async () => {
                    this.model.rusConfigurations = Object.assign({}, this.model.enterpriseRusConfigurations);
                    this.tableData.cleanAndUpdate(this.model.rusConfigurations[this.selectedRus])
                },
                noAction: () => {
                }
            })
            
        },
        /**
         * Cada vez que se modifica la selección del rus, se cargan
         */
        rusSelectedFunction (newValue) {
            this.selectedRus = newValue.name ? newValue.name : newValue;
        },
        keySelectedFunction (newValue, item) {
            item.mapTo = newValue ? newValue.key : '';
        },
        unitSelectedFunction (newValue, item) {
            item.unit = newValue ? newValue.id : '';
        },
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.rusConfigurationForm) {
                this.$refs.rusConfigurationForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (!newModel.ruses) {
                    this.selectedRus = null
                    this.tableData = []
                    this.rusesState = {}
                } else {
                    if (!this.selectedRus) {
                        this.selectedRus = newModel.ruses[0] ? newModel.ruses[0].name : null
                        this.changeSelectedRus()
                    }
                    this.rusesState = {}
                    newModel.ruses.forEach(r => {
                        if (!newModel.rusConfigurations[r.name] || newModel.rusConfigurations[r.name].length <= 0) {
                            this.rusesState[r.name] = { icon: 'mdi-alert-circle', color: 'warning', text: this.$t('enterprise.rusDialog.stateWarning')}
                        } else if (!this.validRus(newModel.rusConfigurations[r.name])) {
                            this.rusesState[r.name] = { icon: 'mdi-close-circle', color: 'error', text: this.$t('enterprise.rusDialog.stateError')}
                        } else {
                            this.rusesState[r.name] = { icon: 'mdi-check-circle', color: 'success', text: this.$t('enterprise.rusDialog.stateSuccess')}
                        }
                    });
                }
            }
        }
    }
}
